export const safeProcessEnv = (key, defaultValue) => {
    const value = process.env[key] || '';
    const result = value || defaultValue;
    // strict check because empty string must be evaluated as true
    if (result === undefined) {
        throw new Error(`Missing key in in .env file: ${key}`);
    }
    return result;
};
export const safeEnv = (key, defaultValue) => {
    const value = process.env[key] || '';
    const result = value || defaultValue;
    // strict check because empty string must be evaluated as true
    if (result === undefined) {
        throw new Error(`Missing key in in .env file: ${key}`);
    }
    return result;
};
export const isLocalTest = () => {
    const env = safeEnv('NEXT_PUBLIC_ENV', '');
    return env === 'local-test';
};
//# sourceMappingURL=env-utils.js.map